export function CheckSolidGreenIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_835_16233)">
        <path
          d="M6 -6.10352e-05C2.688 -6.10352e-05 0 2.68794 0 5.99994C0 9.31194 2.688 11.9999 6 11.9999C9.312 11.9999 12 9.31194 12 5.99994C12 2.68794 9.312 -6.10352e-05 6 -6.10352e-05ZM4.8 8.99994L1.8 5.99994L2.646 5.15394L4.8 7.30194L9.354 2.74794L10.2 3.59994L4.8 8.99994Z"
          fill="#0BEC9F"
        />
      </g>
      <defs>
        <clipPath id="clip0_835_16233">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
